// extracted by mini-css-extract-plugin
export default {"container":"ON-z","error":"PN-z","disabled":"QN-z","submit":"RN-z","option":"SN-z","success":"TN-z","failure":"UN-z"};